import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, ProtectedRoute, configureAuth } from '@webmotors/consumer-shared-auth';
import { EleanorProvider } from '@webmotors/eleanor-ui';
import { Layout } from '@/components/layout';
import { WebmotorsLoader } from '@/components/webmotors-loader';
import { ENV } from '@/app/config';
import { useApp } from '@/app/app.hook';
import { Router } from '@/app/router';

configureAuth({
	env: ENV.AUTH_ENV,
	...(ENV.URL_LOGIN ? { loginUrl: ENV.URL_LOGIN } : {})
});

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5,
			retry: 2,
			refetchOnWindowFocus: false
		}
	}
});

/**
 * Rotas públicas (sem AuthProvider/ProtectedRoute). O /verificacao é aberto
 * por QR code no celular, fora de uma sessão autenticada, então não deve
 * disparar /api/v2/login/renewtoken nem exigir login.
 */
const isPublicRoute = (): boolean =>
	typeof window !== 'undefined' && window.location.pathname.includes('/verificacao');

const App = () => {
	const { isReady } = useApp();

	if (!isReady) {
		return null;
	}

	if (isPublicRoute()) {
		return (
			<QueryClientProvider client={queryClient}>
				<EleanorProvider>
					<Router />
				</EleanorProvider>
			</QueryClientProvider>
		);
	}

	return (
		<QueryClientProvider client={queryClient}>
			<AuthProvider>
				<ProtectedRoute fallback={<WebmotorsLoader />}>
					<EleanorProvider>
						<Layout>
							<Router />
						</Layout>
					</EleanorProvider>
				</ProtectedRoute>
			</AuthProvider>
		</QueryClientProvider>
	);
};

App.displayName = 'App';

export { App };
